import * as angular from "angular";
import {IController} from "angular";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {ShippersAlertsService} from "../../services/shippers-alerts.service";
import {ShippersRequestsService} from "../../services/shippers-requests.service";

export class ShippersListViewCtrl implements IController {

  private loadLimit: number;
  private queryString: string;

  private shippersRef: any;
  private infiniteScroll: any;

  /* @ngInject */
  constructor(private $log, private $infiniteScroll, private $shippers, private shippersRequestsService: ShippersRequestsService,
              private confirmDialogService: ConfirmDialogService, private bringozLoaderService: BringozLoaderService, private shippersAlertsService: ShippersAlertsService) {
  }

  $onInit() {
    this.loadLimit = 20;
    this.queryString = undefined;

    this.shippersRef = this.$shippers();
    this.shippersRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.shippersRef, this.loadLimit);
  }

  // ******************************
  //        Public methods
  // ******************************

  submitQuery(queryString) {
    this.queryString = queryString;
    this._query();
  }

  onDeleteShipper(shipper, $event) {
    let loading = false;
    const text = 'Are you sure you want to delete this shipper?';
    this.confirmDialogService.confirmMask('Delete Shipper', text, $event)
      .then((shouldMask) => {
        loading = true;
        this.bringozLoaderService.on();
        return this.shippersRequestsService.deleteShipper(shipper.id, shouldMask)
      })
      .then((response) => {
        this._query();
        this.shippersAlertsService.deleteOneSuccess(shipper);
      })
      .catch((error) => {
        if (error) {
          this.shippersAlertsService.deleteOneError();
          this.$log.error('Failed to delete shipper @shippersListView@onDeleteShipper', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        if (loading) {
          this.bringozLoaderService.off();
        }
      })
  }

  // ******************************
  //        Private methods
  // ******************************

  _getQueryPayload() {
    return {
      query: this.queryString,
      limit: this.loadLimit
    };
  }

  _query() {
    this.shippersRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Fail to $query', error);
        }
      })
  }

}

angular
  .module('bringoz.admin.shippers')
  .component('shippersListView', {
    bindings: {},
    template: require('./shippers-list-view.html').default,
    controller: ShippersListViewCtrl
  });
